function FilterSidebarFactory(container, autoToggle = false) {
  class FilterSidebar {
    constructor(container, autoToggle) {
      this.filterSidebar = container;
      this.filterTogglers = document.querySelectorAll(
        `[data-toggle-filter="${this.filterSidebar.getAttribute(
          "data-filter-sidebar"
        )}"]`
      );
      this._init();
      if (autoToggle) {
        this._showFilter();
      }
    }
    _init() {
      this._setEvents();
    }
    _showFilter() {
      this.filterSidebar.classList.add("--active");
    }
    _toggleFilter() {
      this.filterSidebar.classList.toggle("--active");
    }
    _setEvents() {
      for (const filterToggler of this.filterTogglers) {
        filterToggler.addEventListener("click", (e) => {
          e.preventDefault();
          if (window.outerWidth >= 700) {
            this._toggleFilter();
          }
        });
      }
    }
  }
  return new FilterSidebar(container, autoToggle);
}
